module.exports = __webpack_public_path__ + "img/send.3536e342.png";